import {
	IsInt,
	IsOptional,
	IsPositive,
	ValidateIf,
} from 'class-validator';
import { GendersEnum } from '../../enums';
import { Transform } from 'class-transformer';
import { stringToInt } from '../../types-transformers/number-transformers';
import { stringToBoolean } from '../../types-transformers/boolean-transformers';
import { arrayOrStringToArray } from '../../types-transformers/array-transformers';

export class SweatPalsFilterDto {
	@Transform(stringToInt)
	@IsInt()
	@IsPositive()
	public ageFrom: number;

	@Transform(stringToInt)
	@IsInt()
	@IsPositive()
	public ageTo: number;

	@IsOptional()
	@ValidateIf(o => !o.shouldLookEverywhere)
	@Transform(stringToInt)
	@IsInt()
	@IsPositive()
	public maxDistance?: number;

	@Transform(stringToBoolean)
	@IsOptional()
	public shouldLookEverywhere?: boolean;

	@IsOptional()
	@Transform(stringToInt)
	@IsInt()
	@IsPositive()
	public limit?: number;

	@Transform(arrayOrStringToArray)
	public genderIds: GendersEnum[];

	@Transform(arrayOrStringToArray)
	public interestIds: string[];
}

export class AddToWatchedDto {
	public watchedUserId: string;
}
